export const general = {
  upload: {
    file_name: "Nombre del archivo",
    file_size: "Tamaño del archivo",
    file_invalid_type: "El tipo de archivo debe ser {{ messageSuffix }}",
    file_too_large: "El archivo es más grande que {{ maxSize }}{{ unit }}",
    file_too_small: "El archivo es más pequeño que {{ minSize }}{{ unit }}",
    too_many_files: "Demasiados archivos, solo se permiten {{ maxFiles }}",
    rejected_header: "Archivos rechazados",
    release_drop: "Arrastra y suelta el archivo aquí",
    select_from_your_computer: "o selecciona desde tu computadora",
  },
  table: {
    reset_table_layout: "Restablecer diseño de tabla",
  },
  access_denied: "No tienes acceso a esta página",
  assign_selected: "Asignar seleccionado",
  Link: "Enlace",
  similarity: {
    High: "Alto",
    Low: "Bajo",
    Medium: "Medio",
    Very_high: "Muy alto",
    Very_low: "Muy bajo",
    score: "Puntuación de similitud",
  },
  show: "Mostrar",
  hide: "Ocultar",
  this_action_cannot_be_undone: "Esta acción no se puede deshacer",
  continue: "Continuar",
  current: "Actual",
  latest: "Última",
  download_excel: "Descargar Excel",
  changes: "Cambios",
  compare: "Comparar",
  tenant_not_provided_for_current_user:
    "Arrendatario para el usuario actual no proporcionado. Verifique la configuración de la vista (función de endpoint)",
  overview: "Resumen",
  only_paying_customers_can_access_this_feature: "Solo los clientes que pagan pueden acceder a esta función",
  add_file_url: "Agregar URL de archivo",
  add_file_URL_button: "Botón para agregar URL de archivo",
  Alert: "Alerta",
  All: "Todos",
  other: "Otros",
  All_changes_have_been_saved: "Se han guardado todos los cambios.",
  All_sub_themes: "Todos los subtemas",
  All_themes: "Todos los temas",
  Apply: "Aplicar",
  Approve: "Aprobar",
  are_you_sure: "¿Estás seguro?",
  Assessment: "Evaluación",
  Assessments: "Evaluaciones",
  Back: "Atrás",
  Cancel: "Cancelar",
  close: "Cerrar",
  Clear_all: "Limpiar todo",
  Collapse_all: "Ocultar todo",
  Companies: "Empresas",
  Confirm: "Confirmar",
  Dashboard: "Panel de control",
  Declined: "Rechazado",
  Delete: "Eliminar",
  Description: "Descripción",
  Deselect_all: "Deseleccionar todo",
  Documentation: "Documentación",
  Duplicate: "Duplicado",
  Edit: "Editar",
  Email: "Correo electrónico",
  Error: "Error",
  Expand_all: "Ampliar todo",
  File: "Archivo",
  First_name: "Nombre de pila",
  Help: "Ayuda",
  hide_menu: "Ocultar menú",
  Important_Notice: "Noticia importante",
  Incorrect_data: "Datos Incorrectos",
  Job_title: "Título profesional",
  Last_update: "Última actualización",
  load_more: "cargar más",
  Next: "Próximo",
  No: "No",
  no_answer: "Sin respuesta",
  No_results: "No hay resultados",
  Notifications: "Notificaciones",
  Ok: "De acuerdo",
  Open_settings: "Configuración abierta",
  or: "u",
  Proceed: "Proceder",
  Protocol: "Protocolo",
  Remove: "Eliminar",
  Reports: "Informes",
  Reset_to_default: "Restablecen a los predeterminados",
  Reviewers: "Revisores",
  Role: "Role",
  roles: {
    Data_provider: "Proveedor de datos",
    data_providers: "Proveedores de datos",
    reviewer: "crítico",
    Reviewer: "Crítico",
    Verifier: "Verificador",
  },
  Roles: "Roles",
  Row: "Fila",
  Save: "Guardar",
  Saving: "Ahorro...",
  search: "buscar",
  Search: "Buscar",
  Search_bar: "Barra de búsqueda",
  Select: "Seleccionar",
  Select_all: "Seleccionar todo",
  show_menu: "Mostrar menú",
  Show_more: "Mostrar más",
  show_less: "Mostrar menos",
  Site: "Sitio",
  Site_creation: "Creación sitio",
  Site_edition: "Edición del sitio",
  Sites: "Sitios",
  Standard: "Estándar",
  standards: "standards",
  SupportPortal: "Portal de soporte",
  Surname: "Apellido",
  there_are_no_files: "No hay archivos.",
  This_field_is_required: "Este campo es obligatorio",
  "Type_name_surname_or_e-mail": "Escriba nombre, apellido o correo electrónico",
  Type_search_text_here: "Escriba el texto de búsqueda aquí",
  Type_to_search: "Escribe para buscar",
  Unsaved_Changes: "Cambios no guardados",
  Upload: "Subir",
  Url: "Url",
  Users: "Usuarios",
  validation: {
    At_last_one_site_is_required: "Por fin se requiere un sitio",
    At_last_one_standard_is_required: "Por fin se requiere un estándar",
    Coordinator_is_required: "Se requiere coordinador",
    Country_is_required: "El país es obligatorio",
    Email_is_used_in_another_company: "El correo electrónico se utiliza en otra empresa",
    Incorrect_email: "Correo electrónico incorrecto",
    name_is_required: "El nombre es obligatorio.",
    Scope_of_applicability_is_required: "Se requiere alcance de aplicabilidad",
    site_is_required: "El sitio es obligatorio.",
    this_field_is_required: "Este campo es obligatorio.",
    This_field_must_be_unique: "Este campo debe ser único.",
  },
  Yes: "Si",
  You_have_unsaved_changes_Are_you_sure_you_want_to_leave:
    "Tienes cambios sin guardar. ¿Estás seguro de que deseas salir?",
  ai_disclaimer: {
    title: "Aviso de Traducción por IA",
    message:
      "Esta traducción de las preguntas del protocolo y los requisitos estándar fue generada usando herramientas de inteligencia artificial y puede contener inexactitudes.",
    accept: "Entiendo",
    go_back: "Volver",
    switch_to_english: "Cambiar a Inglés",
  },
} as const;
